import { render, staticRenderFns } from "./AffEventCallbackTest.vue?vue&type=template&id=3f1219b3&"
import script from "./AffEventCallbackTest.vue?vue&type=script&lang=js&"
export * from "./AffEventCallbackTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports